export { FLIGHT_PLANNER_BASE_URL } from 'hooks/usePlannerFetch/constants';

export const SESSIONS_API = '/api/sessions';

export const WS_PATH_SUFFIX = '/ws';

export const RECONNECT_BACKOFF_MS = [100, 500, 2000];

export const REPLAN_MESSAGE_TYPE = 'replan';

export const PLAN_RESULT_MESSAGE_TYPE = 'planResult';

export const ERROR_MESSAGE_TYPE = 'error';

export const WEBSOCKET_CONNECTION_LOST = 'WebSocket connection lost';

export const CREATE_SESSION_FAILED = 'Failed to create session';

export const ATTACH_PRESCRIPTION_MESSAGE_TYPE = 'attachPrescription';

export const DETACH_PRESCRIPTION_MESSAGE_TYPE = 'detachPrescription';

export const PRESCRIPTION_ATTACHED_MESSAGE_TYPE = 'prescriptionAttached';

export const PRESCRIPTION_DETACHED_MESSAGE_TYPE = 'prescriptionDetached';

export const ATTACH_PRESCRIPTION_FAILED = 'Failed to attach prescription';

export const INVALID_PRESCRIPTION_CODE = 'INVALID_PRESCRIPTION';

export const PRESCRIPTION_TOO_LARGE_CODE = 'PRESCRIPTION_TOO_LARGE';
